// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3zIXk","content":"RecentSearches_content__3bHbX"};